import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CONFIG_MODE } from 'src/app/core/enums/insightConfigurations.enum';
import { PREDICTIVE_CREATE_COMPONENTS } from 'src/app/core/enums/predictiveFailure.enum';
import { SelectedAsset } from 'src/app/core/models/insight-configuration.model';
import { RemoveSelectedAsset, UpdateStepValidity } from 'src/app/core/store/predictive-failure-configuration/predictive-failure-configuration.action';
import { AssetSelectionPopupComponent } from './asset-selection-popup/asset-selection-popup.component';

@Component({
  selector: 'app-predictive-asset-selection',
  templateUrl: './predictive-asset-selection.component.html',
  styleUrls: ['./predictive-asset-selection.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PredictiveAssetSelectionComponent implements OnInit {

  public selectAssetModalRef: BsModalRef
  public selectedAssets: SelectedAsset[] = [];
  public selectedConfigType: any;
  public unsubscribe  = new Subject<void>();
  public dataSource = new MatTableDataSource();
  public selectedAsset : SelectedAsset[];
  public count = 0
  public displayedColumns: string[] = ['name', 'buttons'];
  public disable : boolean;

  public assetDuplicatesDetected: boolean = false;
  public mode = CONFIG_MODE.CREATE;

  constructor(
    public router: Router,
    public modalService: BsModalService,
    private store: Store,
    private changeDetectorRef: ChangeDetectorRef
  ) {}

  @ViewChild('scheduledOrdersPaginator', {static: true}) paginator :MatPaginator;

  ngOnInit(): void {
    this.mode = this.store.selectSnapshot(state => state.configurations.predictiveFailure.mode);
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.getSelectedAssets();
    this.listenToDuplicates();
    
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  public navigateToLanding(): void {
    this.router.navigateByUrl('/home')
  }

  public getSelectedAssets() {
    this.store.select(state => state.configurations.predictiveFailure.assetsSelected).pipe(takeUntil(this.unsubscribe))
    .subscribe(selectedAssets => {
      this.selectedAsset = selectedAssets;
      this.dataSource.data = this.selectedAsset;
      this.count = this.selectedAsset.length
      
      // get flag for if assets are duplicated
      const duplicated = this.store.selectSnapshot(state => state.configurations.predictiveFailure.assetsDuplicateDetected);

      if(this.count > 0){
        if(duplicated) {
          // Set validity to false if there are duplicates
          this.store.dispatch(new UpdateStepValidity(PREDICTIVE_CREATE_COMPONENTS.ASSETS, false));
        } else {
          // Set validity to true if there are duplicates
          this.store.dispatch(new UpdateStepValidity(PREDICTIVE_CREATE_COMPONENTS.ASSETS, true));
        }
      }else if(this.count === 0){
        // Set validity to false if there are duplicates
        this.store.dispatch(new UpdateStepValidity(PREDICTIVE_CREATE_COMPONENTS.ASSETS, false));
      }
      this.changeDetectorRef.detectChanges();
    })
  }

  public listenToDuplicates() {
    this.store.select(state => state.configurations.predictiveFailure.assetsDuplicateDetected).pipe(takeUntil(this.unsubscribe))
    .subscribe(duplicate => {
      this.assetDuplicatesDetected = duplicate;
    })
  }

  public onSelectAssetClicked() {
    this.selectAssetModalRef = this.modalService.show(AssetSelectionPopupComponent, {
      class: 'modal-lg asset-selection',
      ignoreBackdropClick: true
    })
  }

  public deleteSelectedAsset(asset: any) {
    this.store.dispatch(new RemoveSelectedAsset(asset));
  }

  get CONFIG_MODE() {
    return CONFIG_MODE;
  }
}
